module.exports = __webpack_public_path__ + "img/w3_circle_filter_grey.eb454983.png";